import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import WithRender from "@/Pages/Admin/Modules/ManageUsers/Views/manage-users.html";
import Pager from "@/Pages/Admin/Modules/Common/Controllers/Pager";
import ValidationError from "@/Pages/Admin/Modules/Common/Controllers/ValidationError";
import { flashService } from "@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService";
import { trekService } from "@/Pages/Admin/Modules/ManagePackage/Services/Trekservice";
import { common } from "@/Pages/Admin/Modules/Common/Services/Common";

@WithRender
@Component({
  components: {
    Pager,
    "validation-error": ValidationError
  }
})
export default class ManageUsers extends Vue {
  protected ui: any = {};
  protected errors: any = {};
  protected errorsMessage: any = {};
  protected isError: boolean = false;
  protected errorsAttraction: any = {};
  protected UsersList: any = [];
  protected SearchBy: any = {};
  protected paging: any = {};
  protected Disable: any = {};
  protected StatusList: any = [
    { id: "0", name: "Inactive" },
    { id: "1", name: "Active" }
  ];
  constructor() {
    super();
    this.Disable.Disable = false;
    this.Disable.Enable = false;

    this.ui.IsLoading = false;
    this.ui.PostLoading = false;

    this.paging.current_page = 1;
    this.paging.last_page = 0;
    this.paging.per_page = 0;

    this.SearchBy.Username = "";
    this.SearchBy.Email = "";
    this.SearchBy.Status = "";
  }
  public mounted() {
    this.getAllUsersList();
  }
  get permission() {
    return common.permissionCheck;
  }
  public getAllUsersList() {
    this.ui.IsLoading = true;
    let data = {
      // paging: {
      current_page: Number(this.paging.current_page),
      last_page: this.paging.last_page,
      per_page: this.paging.per_page
      // },
      //   search: {
      //     title: this.RequestTitle,
      //     tour_type_id: this.RequestTourType,
      //     difficulty_level_id: this.RequestDifficultyLevel,
      //     pricing_basis_id: this.RequestPricingBasis,
      //     duration: this.RequestDuration ? this.RequestDuration.id : "",
      //     base_price: this.RequestBasePrice ? this.RequestBasePrice.id : ""
      //   },
      // sorting: {
      //   sort_by: "title",
      //   sort_order: "desc"
      // },
    };
    trekService
      .getAllUserList(data)
      .then((res: any) => {
        // console.log("ACCOUT REQUEST LIST", res.data.data);
        res.data.data.data.forEach((item: any) => {
          // console.log("Inside", item.account.status);
          item.SelectAll = false;
          // item.account_modules.forEach((type: any) => {
          //   // console.log("Inside", item);
          //   type.service = false;
          // });
        });
        this.UsersList = res.data.data.data;
        this.ui.IsLoading = false;
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.errorsMessage).then((res: any) => {
          this.isError = true;
          this.errorsMessage = res;
        });
      });
  }
  public activateUser(user: any, user_index: any) {
    console.log(user);
    this.isError = false;
    this.errors = {};
    this.Disable.Enable = true;
    let data = {
      uuid: user.uuid
    };
    // console.log(payLoad);
    this.ui.PostLoading = true;
    trekService
      .useActivate(data)
      .then((res: any) => {
        // console.log("Activate Data", res.data.data);
        this.Disable.Enable = false;
        // this.DepartureList.push(res.data.data);
        this.$set(this.UsersList, user_index, res.data.data);
        flashService.Success("User Activated", res.data.message);
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.errorsMessage).then(res => {
          this.errorsMessage = res;
        });
        // flashService.Error('Error', 'Error while saving Departure');
      })
      .finally(() => {
        this.ui.PostLoading = false;
      });
  }
  public deavtiveUser(user: any, user_index: any) {
    this.isError = false;
    this.errors = {};
    this.Disable.Disable = true;
    let data = {
      uuid: user.uuid
    };
    this.ui.PostLoading = true;
    trekService
      .userDeactivate(data)
      .then((res: any) => {
        // console.log(" Deactive Data", res.data.data);
        this.Disable.Disable = false;
        this.$set(this.UsersList, user_index, res.data.data);
        // this.DepartureList.push(res.data.data);
        flashService.Success("User Deactivated", res.data.message);
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.errorsMessage).then(res => {
          this.errorsMessage = res;
        });
        // flashService.Error('Error', 'Error while saving Departure');
      })
      .finally(() => {
        this.ui.PostLoading = false;
      });
  }
  protected onPaging(CurrentPage: number) {
    // alert(CurrentPage);
    this.UsersList = [];
    this.paging.current_page = CurrentPage;
    this.getAllUsersList();
  }
  protected redirectToInvite() {
    this.$router.push({
      name: "user-invite"
    });
  }
  protected redirectToPendingList() {
    this.$router.push({
      name: "user-pending-invite"
    });
  }
}
